/**
 * @generated SignedSource<<4e43944cb4f4367c72b67af743df3ce5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "activeOnly"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "excludeOneTimeAccepted"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offset"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "accountid",
        "variableName": "accountId"
      },
      {
        "kind": "Variable",
        "name": "activeonly",
        "variableName": "activeOnly"
      },
      {
        "kind": "Variable",
        "name": "excludeonetimeaccepted",
        "variableName": "excludeOneTimeAccepted"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      }
    ],
    "concreteType": "ServiceWithAppDescsConnection",
    "kind": "LinkedField",
    "name": "servicesearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ServiceWithAppDesc",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerServiceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "soAccepted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appSkuPrice",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingFrequency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "billingDayOfMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appSku",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ServicesQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ServicesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9d46ebd7041dd77912cd509c8e744594",
    "id": null,
    "metadata": {},
    "name": "ServicesQuery",
    "operationKind": "query",
    "text": "query ServicesQuery(\n  $accountId: UUID!\n  $activeOnly: Int\n  $excludeOneTimeAccepted: Int\n  $first: Int\n  $offset: Int\n) {\n  servicesearch(accountid: $accountId, activeonly: $activeOnly, excludeonetimeaccepted: $excludeOneTimeAccepted, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      customerServiceId\n      appId\n      serviceStatus\n      soAccepted\n      appSkuPrice\n      billingFrequency\n      billingDayOfMonth\n      appName\n      appSku\n      description\n    }\n  }\n}\n"
  }
};
})();

node.hash = "d06fe118be6aeb3c6eadb03b5998f9f7";

module.exports = node;
